/**
 * @param {*} hNode
 * @returns {(value: string) => string}
 */
// eslint-disable-next-line no-unused-vars
const toLowerCase = hNode => value => value.toString().toLowerCase();

export default toLowerCase;
